<!-- GENERATED FILE -->
<script>
  import { getContext } from "svelte";

  const ctx = getContext("iconCtx") || {};

  export let weight = ctx.weight ?? "regular";
  export let color = ctx.color ?? "currentColor";
  export let size = ctx.size ?? "1em";
  export let mirrored = ctx.mirrored || false;
</script>

<svg 
  xmlns="http://www.w3.org/2000/svg" 
  width={size}
  height={size}
  fill={color}
  transform={mirrored ? "scale(-1, 1)" : undefined} 
  viewBox="0 0 256 256"
  {...$$restProps}>
  <slot/>
  <rect width="256" height="256" fill="none" />
  {#if weight === "bold"}
    <path d="M128,188a11.96187,11.96187,0,0,1-8.48535-3.51465l-80-80a12.0001,12.0001,0,0,1,16.9707-16.9707L128,159.0293l71.51465-71.51465a12.0001,12.0001,0,0,1,16.9707,16.9707l-80,80A11.96187,11.96187,0,0,1,128,188Z"/>
  {:else if weight === "duotone"}
    <g opacity="0.2"><polygon points="208 96 128 176 48 96 208 96"/></g><path d="M128,184a7.97507,7.97507,0,0,1-5.65674-2.34326l-80-79.99976A8,8,0,0,1,48,88H208a8,8,0,0,1,5.65674,13.657l-80,79.99976A7.97507,7.97507,0,0,1,128,184ZM67.314,104,128,164.686,188.686,104Z"/>
  {:else if weight === "fill"}
    <path d="M213.65674,101.657l-80,79.99976a7.99945,7.99945,0,0,1-11.31348,0l-80-79.99976A8,8,0,0,1,48,88H208a8,8,0,0,1,5.65674,13.657Z"/>
  {:else if weight === "light"}
    <path d="M128,182a5.98159,5.98159,0,0,1-4.24268-1.75732l-80-80a6.00006,6.00006,0,0,1,8.48536-8.48536L128,167.51465l75.75732-75.75733a6.00006,6.00006,0,0,1,8.48536,8.48536l-80,80A5.98159,5.98159,0,0,1,128,182Z"/>
  {:else if weight === "thin"}
    <path d="M128,180a3.98881,3.98881,0,0,1-2.82861-1.17139l-80-80.00024a4.00009,4.00009,0,0,1,5.65722-5.65674L128,170.34326l77.17139-77.17163a4.00009,4.00009,0,0,1,5.65722,5.65674l-80,80.00024A3.98881,3.98881,0,0,1,128,180Z"/>
  {:else if weight === "regular"}
    <path d="M128,184a7.97507,7.97507,0,0,1-5.65674-2.34326l-80-79.99976A8,8,0,1,1,53.65674,90.343L128,164.686l74.34326-74.343a8,8,0,0,1,11.31348,11.314l-80,79.99976A7.97507,7.97507,0,0,1,128,184Z"/>
  {:else}
    {(console.error('Unsupported icon weight. Choose from "thin", "light", "regular", "bold", "fill", or "duotone".'), "")}
  {/if}
</svg>